module.exports = __webpack_public_path__ + "img/product.81107dbb.png";